import React, { useState } from 'react';
import { 
    Box, 
    Flex, 
    Text, 
    Button,
    Divider,
    Radio,
    Stack,
    RadioGroup
} from '@chakra-ui/react';
import { cards } from '../../../utilities/dummy';

export default function BillingPaymentInfo() {
    const [selectedCard, setSelectedCard] = useState<string>(cards[0]?.id);

    function handleCardChange(val: string) {
        setSelectedCard(val)
    }

    return (
        <Box paddingY={'6'} paddingTop='1'>
            <Box marginTop={'6'}>
                <Box marginBottom={'2'} paddingBottom='2' paddingTop='2' justifyContent={'space-between'} alignItems='center'>
                    <Text fontSize='lg'  marginBottom={'4'} color='gray.600' fontWeight={'bold'}>Billing cards</Text>
                    <Divider />
                    <Box marginTop='4'>
                        <RadioGroup onChange={handleCardChange} value={selectedCard} width='full'>
                            <Stack width='full'>
                                {cards.map((card) => (
                                    <>
                                        <Flex alignItems={'center'} justifyContent='space-between' width='full' marginTop={'2'} marginBottom={'4'} >
                                            <Radio value={card.id} size='md' width='full' maxWidth='full'>
                                                <Box>
                                                    <Text fontSize='sm' color='gray.600' textTransform={'capitalize'} fontWeight={'semibold'}>
                                                        {card.type}
                                                        <span> {card.masked}</span>
                                                    </Text>
                                                    <Text fontSize={'sm'} color='gray.500'>
                                                        Expiry: {card.expDate}
                                                    </Text>
                                                </Box>
                                            </Radio>
                                            <Flex alignItems={'center'}>
                                                <Button variant='ghost' size={'sm'} mr={3} colorScheme='red'>
                                                    Delete
                                                </Button>
                                                <Button 
                                                    variant='outline' 
                                                    size={'sm'} 
                                                    borderColor={'blue.600'}
                                                    background='whiteAlpha.700'
                                                    color={'blue.500'}
                                                >
                                                    Edit
                                                </Button>
                                            </Flex>
                                        </Flex>
                                        <Divider />
                                    </>
                                ))}
                            </Stack>
                        </RadioGroup>
                    </Box>
                </Box>
            </Box>
        </Box>
    )
}